/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Model_FranchisorInputs */

const cs_franchise_model_franchisor = /** @type {(inputs: Franchise_Model_FranchisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionální franchisor`)
};

const en_franchise_model_franchisor = /** @type {(inputs: Franchise_Model_FranchisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional franchisor`)
};

/**
* | output |
* | --- |
* | "Regional franchisor" |
*
* @param {Franchise_Model_FranchisorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_model_franchisor = /** @type {((inputs?: Franchise_Model_FranchisorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Model_FranchisorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_model_franchisor(inputs)
	return cs_franchise_model_franchisor(inputs)
});